'use client'

import classNames from 'classnames'
import React, { useCallback, useEffect } from 'react'

import { ReactComponent as CopyIcon } from '~/assets/icons/copy.svg'

// import { Container } from './styles';
interface Props {
  shareUrl: string
}

const CopyButton: React.FC<Props> = ({ shareUrl }) => {
  const [isTooltipVisible, setTooltipVisible] = React.useState(false)

  useEffect(() => {
    if (!isTooltipVisible) {
      return
    }

    const timeout = setTimeout(() => {
      setTooltipVisible(false)
    }, 1200)

    return () => {
      clearTimeout(timeout)
    }
  }, [isTooltipVisible])

  const onClickCopy = useCallback(() => {
    navigator.clipboard.writeText(shareUrl)
    setTooltipVisible(!isTooltipVisible)
  }, [shareUrl, isTooltipVisible])

  return (
    <div className="w-6 h-6 relative group">
      <button
        aria-label="Copiar Link da Pagina"
        onClick={onClickCopy}
        className="hover:text-hover-color"
      >
        <CopyIcon className="w-6 h-6" />
      </button>
      <div
        className={classNames(
          'absolute text-neutral-black p-2 z-50 top-[150%] left-1/2 -translate-x-1/2 bg-neutral-white flex flex-col shadow-lg w-max transition-[opacity,transform] duration-300',
          {
            'opacity-100 scale-100 origin-top pointer-events-auto ease-out':
              isTooltipVisible,
            'opacity-0 scale-50 origin-top pointer-events-none ease-in':
              !isTooltipVisible,
          }
        )}
      >
        <div className="absolute top-[-0.25rem] left-1/2 -translate-x-1/2 w-0 h-0 border-b-[0.375rem] border-l-[0.375rem] border-r-[0.375rem] border-transparent border-b-neutral-white" />
        <p className="text-xs">Copiado!</p>
      </div>
    </div>
  )
}

export default CopyButton
